import {Injectable, NgZone} from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class FullscreenService {

    private isExpanded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor(private readonly _ngZone: NgZone) {
    }

    private state = false;

    emitIsExpanded(isExpanded: boolean) {
        return this.isExpanded.next(isExpanded);
    }

    getIsExpandedObservable() {
        return this.isExpanded.asObservable();
    }

    getIsExpanded() {
        return this.isExpanded.getValue();
    }

    toggle() {
        if (this.state) {
            this.deactivate();
        } else {
            this.activate();
        }
    }

    activate() {
        this.state = true;
        return new Promise((resolve) => {
            this._ngZone.run(resolve);
        });
    }

    deactivate() {
        this.state = false;
        return new Promise((resolve) => {
            this._ngZone.run(resolve);
        });
    }

    isActive() {
        return this.state;
    }
}
